// The Irish site is served by a separate codebase, so its URL cannot be derived from this
// application's environment configuration and has no per-environment variant.
export const IRISH_SITE_HREF = 'https://gousto.ie/'

/**
 * hreflang annotations declaring gousto.ie as the Irish country variant of this page.
 *
 * Emitted on the homepage only: an hreflang cluster must name equivalent pages, and we cannot
 * verify an Irish equivalent for any other route from this codebase.
 *
 * @param ukHref absolute URL of the UK homepage for the current environment, so that a
 * non-production deployment never advertises production URLs.
 */
export const getHreflangLinks = (ukHref: string) => [
  { rel: 'alternate', hreflang: 'en-gb', href: ukHref },
  { rel: 'alternate', hreflang: 'en-ie', href: IRISH_SITE_HREF },
  { rel: 'alternate', hreflang: 'x-default', href: ukHref },
]
